import React from 'react'

import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { submitFooterForm } from '../../_actions'
import { email } from '../../_helpers'
import {
    Container,
    Row,
    devices,
    minDevices,
    colors,
    Button,
    Input,
    Textarea,
    Form,
    SmallArrow,
    FormError,
} from '../Common'


export const Footer = () => {
    const { register, handleSubmit, errors } = useForm({ mode: 'onBlur' })
    const { footerMessage, footerError } = useSelector(state => state.content, shallowEqual)
    const dispatch = useDispatch()
    const onSubmit = data => dispatch(submitFooterForm(data))

    const formOptions = { required: 'This field is required' }

    return (
        <FooterWrap>
            <FooterContainer>
                <FooterRow basis={33}>
                    <FooterHeading>Contact Us</FooterHeading>
                    {footerMessage || footerError ? (
                        <Message>{footerMessage || footerError}</Message>
                    ) : (
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                {errors.name && <FormError color={colors.white}>This field is required</FormError>}
                                <Input color={colors.inputRed} aria-label="name" name="name" type="text" placeholder="Name" ref={register(formOptions)} />
                                {errors.email && <FormError color={colors.white}>{errors.email.message}</FormError>}
                                <Input color={colors.inputRed} aria-label="email" name="email" type="email" placeholder="Email" ref={register({ ...formOptions, validate: val => email(val) })} />
                                {errors.subject && <FormError color={colors.white}>This field is required</FormError>}
                                <Input color={colors.inputRed} aria-label="subject" name="subject" type="text" placeholder="Subject" ref={register(formOptions)} />
                                {errors.message && <FormError color={colors.white}>This field is required</FormError>}
                                <Textarea aria-label="message" name="message" placeholder="Message" ref={register(formOptions)} />
                                <Button margintop={20} type='submit' onClick={handleSubmit(onSubmit)}>SUBMIT</Button>
                            </Form>
                        )}
                </FooterRow>
                <AddressRow basis={20}>
                    <EventFormLink as={Link} to={'/event-form/'}>Event form <SmallArrow /> </EventFormLink>
                    <div>
                        <FooterHeading>Info</FooterHeading>
                        <Address>
                            626 West Cavalcade<br />
                            Houston, TX 77009<br />
                            Phone: <a href="tel:7138613331">713.861.3331</a><br />
                            <br />
                            Visit Our Warehouse<br />
                            — By appointment only
                        </Address>
                        <Icons>
                            <Instagram aria-label='Instagram' href='https://www.instagram.com/artattackeventco/' target='_blank' rel='noopener noreferrer' />
                            <Facebook aria-label='Facebook' href='https://www.facebook.com/artattackco/' target='_blank' rel='noopener noreferrer' />
                            <Linkedin aria-label='Linkedin' href='https://www.linkedin.com/' target='_blank' rel='noopener noreferrer' />
                        </Icons>
                    </div>
                </AddressRow>
                <FooterRow basis={30} />
            </FooterContainer>
        </FooterWrap>
    )
}

const FooterWrap = styled.footer`
    padding-top: 50px;
    padding-bottom: 50px;
    width: 100%;
    background: ${colors.red};
    color: ${colors.white};

    @media ${devices.small} {
        padding-bottom: 100px;
    }
`

const Address = styled.div`
    a {
        text-decoration: none;
        color: ${colors.white};
    }
`

const FooterContainer = styled(Container)`
    display: flex;
    justify-content: space-between;
    width: auto;

    @media ${devices.small} {
        flex-direction: column;
    }
`

const Message = styled.div``

const FooterHeading = styled.div`
    text-transform: uppercase;
    margin-bottom: 5px;
    font-family: pragmatica-extended, sans-serif;
    font-weight: 900;
    font-style: normal;
    font-size: 14px;
`

const EventFormLink = styled(FooterHeading)`
    position: relative;
    text-decoration: none;
    color: ${colors.white};
    display: flex;
    align-items: center;

    @media ${devices.small} {
        margin-bottom: 50px;
    }
`

const FooterRow = styled(Row)`
    flex-direction: column;
    justify-content: flex-start;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: ${({ basis }) => basis}%;
    @media ${devices.small} {
        margin-bottom: 30px;
    }
`

const AddressRow = styled(FooterRow)`
    justify-content: space-between;
    @media ${minDevices.medium} {
        margin-left: auto;
    }

    @media ${devices.small} {
        order: 2;
    }

    @media ${devices.medium_portrait} {
        flex-basis: auto;
    }
`

const Icons = styled.div`
    margin-top: 20px;
`

const SocialIcon = styled.a`
    background-image: url('/static/images/sprite.svg');
    background-repeat: no-repeat;
    background-position-y: -125px;
    margin-right: 10px;
    display: inline-block;
`

const Facebook = styled(SocialIcon)`
    background-position-x: -100px;
    width: 23px;
	height: 22px;
`

const Linkedin = styled(SocialIcon)`
    background-position-x: -127px;
    width: 22px;
	height: 22px;
`

const Instagram = styled(SocialIcon)`
    background-position: -127px -100px;
	width: 23px;
	height: 22px;
`


